<template>
  <div class="item-container" @click="goto(jinNangId)">
    <div class="jinNang-row">
      <span class="title s8 t1">{{ title }}</span>
      <span
        v-for="(item, index) in tags"
        :key="index"
        class="tag s2 c5"
      >{{ item.text }}</span>
      <span
        class="shouyi s11 c1"
        :class="{ 'negative-color': !isPositive(kindRate) }"
      >{{ kindRate }}</span>
    </div>
    <div class="jinNang-row mt-20">
      <span class="s4 t3">{{ authorName }}</span>
      <span class="s4 t3 ml-10 mr-10">|</span>
      <span class="s4 t3">胜率:{{ selwinidx }}</span>
      <span class="s4 t3">回撤率:{{ maxdrawidx }}</span>
      <span class="zongshouyi s4 t3">{{kindFont}}</span>
    </div>
    <div class="jinNang-row mt-30">
      <span class="jinNang-createTime s2 t3">创建日期 {{ convertTime(createTime) }}</span>
      <span
        class="jinNang-createTime s2 t3"
      >打理日期 {{ convertTime(lastOperateTime) }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'JinNangListItem',
  props: {
    item: {
      type: Object
    },
    sortType: {
      type: Number
    },
    jinNangId: {
      type: Number
    },
    title: {
      type: String
    },
    tags: {
      type: Array
    },
    glYield: {
      type: String
    },
    yearYield: {
      type: String
    },
    authorName: {
      type: String
    },
    authorTitle: {
      type: String
    },
    authorCompany: {
      type: String
    },
    selwinidx: {
      type: String
    },
    maxdrawidx: {
      type: String
    },
    createTime: {
      type: Number
    },
    lastOperateTime: {
      type: Number
    }
  },
  computed: {
    kindRate() {
      let rate = this.item.glYield
      switch (this.sortType) {
        case 1:
          rate = this.item.dayYield
          break
        case 2:
          rate = this.item.weekYield
          break
        case 3:
          rate = this.item.monthYield
          break
        case 4:
          rate = this.item.qrtYield
          break
        case 5:
          rate = this.item.yearYield
          break
      }
      return rate
    },
    kindFont() {
      let font = '总收益'
      switch (this.sortType) {
        case 1:
          font = '日收益'
          break
        case 2:
          font = '周收益'
          break
        case 3:
          font = '月收益'
          break
        case 4:
          font = '季收益'
          break
        case 5:
          font = '年收益'
          break
      }

      return font
    }
  },
  methods: {
    convertTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    isPositive(rate) {
      const pos = rate.search('-')

      return pos < 0
    },
    goto(jinNangId) {
      this.$emit('goto')
    }
  }
}
</script>

<style lang="scss" scoped>
.item-container {
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 30px 30px;
}
.jinNang-row {
  .title {
    margin-right: 26px;
    float: left;
  }
  .tag {
    text-align: center;
    // height: 32px;
    margin-right: 10px;
    border: 1px solid #046bcc;
    border-radius: 5px;
    line-height: normal;
    padding: 1px 10px;
    float: left;
  }
  .shouyi {
    float: right;
    font-weight: bold;
  }
  .author-tag {
    float: left;
  }
  .zongshouyi {
    float: right;
  }
  .jinNang-createTime {
    margin-right: 20px;
    background-color: rgba(85, 85, 85, 0.1);
    padding: 6px 15px;
    border-radius: 5px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-30 {
    margin-top: 30px;
  }
  .positive-color {
    color: #e64c2e;
  }
  .negative-color {
    color: #38bf26;
  }
}
</style>
